import { DeviceRegistry } from '../../../types';

type SpeakerProps = {
  deviceRegistry: DeviceRegistry;
  id: string;
  label: string;
  description?: string;
};

export class Speaker {
  id: string;
  label: string;
  private description: string;
  private deviceRegistry: DeviceRegistry;

  constructor(props: SpeakerProps) {
    this.deviceRegistry = props.deviceRegistry;
    this.id = props.id;
    this.label = props.label;
    this.description = props.description ?? '';
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }

  isDefault(): boolean {
    const defaultSpeaker = this.deviceRegistry
      .getDevicesInfo()
      .find((device) => device.kind === 'audiooutput' && device.deviceId === 'default');
    return defaultSpeaker?.deviceId === this.getId() || this.getId() === 'default';
  }

  getDescription(): string {
    return this.description;
  }
}
